


import keyMirror from "keymirror";
 export const Approval = {
   ActionTypes: keyMirror({
     // employee home
     FETCHOVERTIMELISTSSUCCESS: null,
    
   })
};


// WEBPACK FOOTER //
// ./src/constants/approval-constants.js